import { render, staticRenderFns } from "./LaserReceiver.vue?vue&type=template&id=10176d28&"
import script from "./LaserReceiver.vue?vue&type=script&lang=js&"
export * from "./LaserReceiver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports